enum SDS_STATEMENTS_TABLE_TYPE {
  PECAUTIONARY = 'PRECAUTIONARY_STATEMENT',
  HAZARD = 'HAZARD_STATEMENT',
  EUH = 'EUH_STATEMENT',
}

export default SDS_STATEMENTS_TABLE_TYPE;
